/** Shopify CDN: Minification failed

Line 34:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 36:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 45:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 49:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 23:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 25:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 25:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 27:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 34:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 12:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 14:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 18:50 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 23:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 27:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async() => {

    const { Core } = await importModule('Core');
    
    const CN_ACTIVE = '!active';

    customElements.define('product-info-loading', class extends Core {
        subscriptions = {
            'variant:loading': '_handleLoading'
        }
       
        render() {
            this.subscribe('variant:loading', { global: true });
        }
        
        _handleLoading(state) {
            this.classList.toggle(CN_ACTIVE, state);
        }
    });

})();